import { Breadcrumb as AntdBreadcrumb } from 'antd';
import {
  BreadcrumbProps as AntdBreadcrumbProps,
  BreadcrumbItemProps as AntdBreadcrumbItemProps,
} from 'antd/lib/breadcrumb';

export type BreadcrumbProps = AntdBreadcrumbProps;
export type BreadcrumbItemProps = AntdBreadcrumbItemProps;

export const Breadcrumb = AntdBreadcrumb;

export default AntdBreadcrumb;
